export const GITHUB_ORG = 'mac-duo';

export const GITHUB_OWNER = 'charlite';

export const GITHUB_ORG_URL = `https://github.com/${GITHUB_ORG}`;

export const GITHUB_PROFILE_URL = `https://github.com/${GITHUB_OWNER}`;

/** App Store listing name */
export const APP_NAME = 'MacDUO';

/** Short brand name for compact UI */
export const APP_NAME_SHORT = 'MacDUO';

/** Set when the Mac App Store listing is live */
export const APP_STORE_URL: string | null = null;

/** App Store promotional text (170 char max) */
export const APP_STORE_PROMOTIONAL_TEXT =
  'MacDUO brings the iPhone Duo closing fold to your MacBook — a full-screen animation inspired by Duo’s satisfying shut.';

export const SITE_URL = 'https://mac-duo.pages.dev';

export const SUPPORT_URL = `${SITE_URL}/contact`;
